import { App } from 'vue';

import KitDetails, {
  type KitItemData
} from '@/components/Cart/MiniCart/MiniCartLineItem/KitItems.vue';
import { createCoreVueApp } from '@/entrypoints/helpers/core-vue-app';

export const KIT_DETAILS_MOUNT_SELECTOR = '.js-kit-details-mount';

let mountedKitApps: App[] = [];

export function parseKitDetails(raw: string): KitItemData[] {
  return raw.split(', ').flatMap((entry) => {
    const parts = entry.split(' : ');
    const variantId = parts[0]?.trim();
    const quantity = parseInt(parts[1] ?? '1', 10);
    if (!variantId || Number.isNaN(quantity)) return [];
    return [{ variantId, quantity }];
  });
}

export const initCartLineKitDetails = async (): Promise<void> => {
  mountedKitApps.forEach((app) => app.unmount());
  mountedKitApps = [];

  const mounts = Array.from(
    document.querySelectorAll<HTMLElement>(KIT_DETAILS_MOUNT_SELECTOR)
  );
  if (mounts.length === 0) return;

  const apps = await Promise.all(
    mounts.map(async (mount) => {
      const raw = mount.dataset.kitDetails;
      if (!raw) return null;

      const items = parseKitDetails(raw);
      if (items.length === 0) return null;

      const app = await createCoreVueApp(KitDetails, mount, { items });
      app.mount(mount);
      return app;
    })
  );

  mountedKitApps = apps.filter((app): app is App => app !== null);
};
